import React, { useEffect } from 'react';
import MaterialTable from 'material-table';
import { useForm } from 'react-hook-form';
import Select from 'react-select'
import Switch from "react-switch";

// reactstrap components
import {
    Button, Card, CardBody, CardHeader, FormGroup, Form, Input, Row, Col, Nav, NavItem,
    NavLink, TabPane, TabContent, InputGroup, InputGroupAddon, InputGroupText,
    Modal, ModalHeader, ModalBody, ModalFooter, CustomInput, Tooltip
} from "reactstrap";

// helpers
import { transformValueFloattoFormated } from "helpers/formats.js";

// style
import "assets/css/loading.css";

// services
import { showMessage, showQuestion } from "services/message.js";
import { api_GET, api_POST, api_PUT } from "services/api_service.js";
import ValidaAcessoFuncionalidadeAcao from "services/acesso.js";
import { getSessionCookie } from "services/session.js";

export default function CadastroSolicitacaoForm({ item, handleReturn }) {

    const { register, handleSubmit, errors, setError, setValue, clearErrors, getValues } = useForm({ mode: "onBlur" });
    const [showLoading, setshowLoading] = React.useState(false);
    let session = getSessionCookie();
    const [permiteEditar, set_permiteEditar] = React.useState(false);

    const [setupSolicitacao_Id, set_setupSolicitacao_Id] = React.useState(0);

    // Status
    const [status, set_status] = React.useState("");
    const [options_status] = React.useState([
        { value: "Ativo", label: "Ativo" },
        { value: "Inativo", label: "Inativo" },
    ]);
    const handleStatus = (value) => {
        set_status(value);
        setValue("status", value, true);
        clearErrors("status");
    }

    // Segmento
    const [segmento, set_segmento] = React.useState("");
    const [options_segmento] = React.useState([
        { value: "Destino Final", label: "Destino Final" },
        { value: "Grande Gerador", label: "Grande Gerador" },
        { value: "Transportador", label: "Transportador" },
    ]);
    const handleSegmento = (value) => {
        set_segmento(value);
        setValue("segmento", value, true);
        clearErrors("segmento");
        loadOptionsCategoria(value);
    }

    // Categoria
    const [categoria, set_categoria] = React.useState(null);
    const [options_categoria, set_options_categoria] = React.useState([]);
    const loadOptionsCategoria = (_segmento) => {
        api_GET(`Categoria/GetListBySegmento/${_segmento}`).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_options_categoria(result.data);
            }
        });
    }
    const handleCategoria = (value) => {
        set_categoria(value);
        setValue("categoria", value, true);
        clearErrors("categoria");
    }

    // Tipo Pessoa
    const [tipoPessoa, set_tipoPessoa] = React.useState("");
    const [options_tipoPessoa] = React.useState([
        { value: "Física", label: "Pessoa Física" },
        { value: "Jurídica", label: "Pessoa Jurídica (Privado)" },
        { value: "Pública", label: "Pessoa Jurídica (Público)" },
        { value: "Ambos", label: "Ambos" },
    ]);
    const handleTipoPessoa = (value) => {
        set_tipoPessoa(value);
        setValue("tipoPessoa", value, true);
        clearErrors("tipoPessoa");
    }

    const [permiteCadastroDuplicado, set_permiteCadastroDuplicado] = React.useState(false);
    const handleChangePermiteCadastroDuplicado = (checked) => {
        set_permiteCadastroDuplicado(checked);
    }

    // Ações
    const [acao, set_acao] = React.useState("");
    const [options_acao] = React.useState([
        { value: "Alteração", label: "Alteração de Cadastro" },
        { value: "Alteração de Identificação", label: "Alteração de Identificação" },
        { value: "Alteração de Equipamentos", label: "Alteração de Equipamentos" },
        { value: "Aumento de Capacidade", label: "Aumento de Capacidade" },
        { value: "Cancelamento", label: "Cancelamento" },
        { value: "Exclusão", label: "Exclusão" },
        { value: "Inclusão", label: "Inclusão" },
        { value: "Novo Cadastro", label: "Novo Cadastro" },
        { value: "Renovação", label: "Renovação" }
    ]);
    
    const handleAcao = (value) => {
        set_acao(value);
        setValue("acao", value, true);
        clearErrors("acao");
    }

    // Status Ação
    const [statusAcao, set_statusAcao] = React.useState("");
    const [options_statusAcao] = React.useState([
        { value: "Ativo", label: "Ativo" },
        { value: "Inativo", label: "Inativo" },
    ]);
    const handleStatusAcao = (value) => {
        set_statusAcao(value);
        setValue("statusAcao", value, true);
        clearErrors("statusAcao");
    }

    // Enquadramento Obrigatório
    const [enquadramentoObg, set_enquadramentoObg] = React.useState("");
    const [options_enquadramentoObg] = React.useState([
        { value: "true", label: "Sim" },
        { value: "false", label: "Não" },
    ]);
    const handleEnquadramentoObg = (value) => {
        set_enquadramentoObg(value);
        setValue("enquadramentoObg", value, true);
        clearErrors("enquadramentoObg");
    }

     // Cancelar Requerimentos
     const [cancelarRequerimentos, set_cancelarRequerimentos] = React.useState("");
     const [options_cancelarRequerimentos] = React.useState([
         { value: "true", label: "Sim" },
         { value: "false", label: "Não" },
     ]);
     const handleCancelarRequerimentos = (value) => {
        set_cancelarRequerimentos(value);
         setValue("cancelarRequerimentos", value, true);
         clearErrors("cancelarRequerimentos");
     }

    // Diário Oficial
    const [diarioOficial, set_diarioOficial] = React.useState("");
    const [options_diarioOficial] = React.useState([
        { value: "true", label: "Sim" },
        { value: "false", label: "Não" },
    ]);
    const handleDiarioOficial = (value) => {
        set_diarioOficial(value);
        setValue("diarioOficial", value, true);
        clearErrors("diarioOficial");
    }

    // Modal Documentos
    const [optionsDocumentos, set_optionsDocumentos] = React.useState([]);
    const [optionsDocumentosSelected, set_optionsDocumentosSelected] = React.useState([]);
    const loadOptionsDocumentos = () => {
        api_GET('documento/ativos').then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                set_optionsDocumentos(result.data);
            }
        });
    }
    const toggleModalDocumentos = () => {
        setModal(!modal);
    }
    const confirmarModalDocumentos = () => {
        setModal(false);
    }
    const handleDocumentoChange = (value, documento_Id) => {
        let _documentos = optionsDocumentosSelected;

        if (value)
            _documentos.push(documento_Id);
        else
            _documentos = _documentos.filter(f => f != documento_Id);

        set_optionsDocumentosSelected(_documentos);
    }

    const [rowEdit, set_rowEdit] = React.useState(null);
    const [list_table_acoes, set_list_table_acoes] = React.useState([]);

    const handleEditarAcao = (rowData) => {
        set_rowEdit(rowData);
        set_acao(rowData.acao);
        setValue("acao", rowData.acao, true);
        set_statusAcao(rowData.status);
        setValue("statusAcao", rowData.status, true);
        set_enquadramentoObg(rowData.enquadramentoObrigatorio.toString())
        setValue("enquadramentoObg", rowData.enquadramentoObrigatorio.toString(), true);
        set_cancelarRequerimentos(rowData.cancelarRequerimentos.toString());
        setValue("cancelarRequerimentos", rowData.cancelarRequerimentos.toString(), true);
        set_diarioOficial(rowData.publicaDiarioOficial.toString());
        setValue("diarioOficial", rowData.publicaDiarioOficial.toString(), true);
        setValue("codigoCobranca", rowData.codigoCobranca);
        setValue("identificacao", rowData.identificacao);
        setValue("valor", rowData.valorGuia);
        setValue("prazoCobranca", rowData.prazoVencimentoCobrancaEmDias);

        let _documentos = [];
        rowData.acaoDocumentos.map(m => {
            _documentos.push(m.documento_Id);
        })
        set_optionsDocumentosSelected(_documentos);
    }

    // Adicionar Ação
    const confirmacaoAcaoAdicionada = (item) => {
        let new_list = [];
        list_table_acoes.map(m => {
            if (m.setupSolicitacaoAcao_Id == item.setupSolicitacaoAcao_Id)
                new_list.push(item);
            else
                new_list.push(m);
        });
        if (list_table_acoes.filter(f => f.setupSolicitacaoAcao_Id == item.setupSolicitacaoAcao_Id).length == 0)
            new_list.push(item);

        set_list_table_acoes(new_list);

        set_rowEdit(null);
        set_acao("");
        setValue("acao", "", false);
        set_statusAcao("");
        setValue("statusAcao", "", false);
        set_enquadramentoObg("")
        setValue("enquadramentoObg", "", false);
        set_cancelarRequerimentos("");
        setValue("cancelarRequerimentos", "", false);
        set_diarioOficial("");
        setValue("diarioOficial", "", false);
        setValue("valor", "");
        setValue("prazoCobranca", "");
        set_optionsDocumentosSelected([]);
    }

    const handleAdicionarAcao = () => {
        let data = getValues();
        let error = false;

        if (acao == "" || statusAcao == "" || enquadramentoObg == "" || diarioOficial == "" || data.valor == "" || data.prazoCobranca == "")
            error = true;

        if (error) {
            showMessage("Aviso", "Preencha todos os campos", 'error', null);
            return;
        }

        let documentos = [];
        optionsDocumentosSelected.map(m => {
            if (documentos.filter(f => f.documento_Id == m).length == 0) {
                documentos.push({
                    setupSolicitacaoAcao_Id: rowEdit != null ? rowEdit.setupSolicitacaoAcao_Id : 0,
                    documento_Id: m
                });
            }
        });

        let json_submit = {
            setupSolicitacaoAcao_Id: rowEdit != null ? rowEdit.setupSolicitacaoAcao_Id : 0,
            setupSolicitacao_Id: setupSolicitacao_Id,
            acao: acao,
            enquadramentoObrigatorio: enquadramentoObg,
            cancelarRequerimentos: cancelarRequerimentos,
            publicaDiarioOficial: diarioOficial,
            valorGuia: data.valor,
            codigoCobranca: data.codigoCobranca,
            prazoVencimentoCobrancaEmDias: data.prazoCobranca,
            status: statusAcao,
            acaoDocumentos: documentos,
            usuarioUltimaAlteracao_Id: session.usuario_Id,
            identificacao: data.identificacao
        }

        setshowLoading(true);
        if (json_submit.setupSolicitacaoAcao_Id == 0) {
            api_POST('SetupSolicitacao/PostAcao', json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                        confirmacaoAcaoAdicionada(result.data);
                    });
                }
            });
        }
        else {
            api_PUT('SetupSolicitacao/PutAcao', json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                        confirmacaoAcaoAdicionada(result.data);
                    });
                }
            });
        }
    }

    // Remover Ação
    const handleDeleteAcao = (rowData) => {
        showQuestion("Aviso", "Tem certeza que quer deletar o registro?", 'question', function (retorno) {
            if (retorno) {
                setshowLoading(true);
                api_POST('SetupSolicitacao/DeleteAcao', rowData).then(result => {
                    setshowLoading(false);
                    if (result.status !== 200) {
                        showMessage("Aviso", result.message, 'error', null);
                    }
                    else {
                        showMessage("Aviso", "Operação executada com sucesso!", 'success', null);
                        let new_list = list_table_acoes.filter(f => f.setupSolicitacaoAcao_Id != rowData.setupSolicitacaoAcao_Id);
                        set_list_table_acoes(new_list);
                    }
                });
            }
        });
    }

    const [tooltipOpen, setTooltipOpen] = React.useState(false);
    const toggleTip = () => setTooltipOpen(!tooltipOpen);

    const Voltar = (event, rowData) => {
        handleReturn();
    }

    const [h1_tab, set_h1_tab] = React.useState("ht1");
    const [modal, setModal] = React.useState(false);

    const loadItem = () => {
        setValue("acao", "", false);
        setValue("statusAcao", "", false);
        setValue("enquadramentoObg", "", false);
        setValue("diarioOficial", "", false);
        if (item != null) {
            set_setupSolicitacao_Id(item.setupSolicitacao_Id);
            setValue("descricao", item.descricao);
            set_status(item.status);
            setValue("status", item.status, true);
            set_segmento(item.segmento);
            setValue("segmento", item.segmento, true);
            loadOptionsCategoria(item.segmento);
            set_categoria(item.categoria_Id);
            setValue("categoria", item.categoria_Id, true);
            set_tipoPessoa(item.pessoa);
            setValue("tipoPessoa", item.pessoa, true);
            setValue("vigencia", item.vigenciaEmMeses);
            setValue("primeiraNotificacao", item.notificacao1RenovacaoEmDias);
            setValue("segundaNotificacao", item.notificacao2RenovacaoEmDias);
            setValue("terceiraNotificacao", item.notificacao3RenovacaoEmDias);
            setValue("declaracao", item.descricaoDeclaracao);
            set_permiteCadastroDuplicado(item.permiteCadastroDuplicado);
            set_list_table_acoes(item.solicitacaoAcoes);
            setValue("cabecalhoCertificado", item.cabecalhoCertificado);
            setValue("legislacaoCertificado", item.legislacaoCertificado);
        }
        else {
            set_setupSolicitacao_Id(0);
            setValue("descricao", "");
            set_status("");
            setValue("status", "", false);
            set_segmento("");
            setValue("segmento", "", false);
            set_categoria("");
            set_options_categoria([]);
            setValue("categoria", null, false);
            set_tipoPessoa("");
            setValue("tipoPessoa", "", false);
            setValue("vigencia", "");
            setValue("primeiraNotificacao", "");
            setValue("segundaNotificacao", "");
            setValue("terceiraNotificacao", "");
            setValue("declaracao", "");
            set_permiteCadastroDuplicado(false);
            setValue("cabecalhoCertificado", "");
            setValue("legislacaoCertificado", "");
        }
    }

    useEffect(() => {
        ValidaAcessoFuncionalidadeAcao("CadastroSolicitacao.Editar", function (result) { set_permiteEditar(result) });
        loadOptionsDocumentos();
        loadItem();
    }, [item]);

    const onSubmit = (data) => {
        let json_submit = {
            setupSolicitacao_Id: setupSolicitacao_Id,
            descricao: data.descricao,
            segmento: segmento,
            categoria_Id: categoria,
            pessoa: tipoPessoa,
            vigenciaEmMeses: data.vigencia,
            notificacao1RenovacaoEmDias: data.primeiraNotificacao,
            notificacao2RenovacaoEmDias: data.segundaNotificacao,
            notificacao3RenovacaoEmDias: data.terceiraNotificacao,
            descricaoDeclaracao: data.declaracao,
            status: status,
            usuarioCadastro_Id: session.usuario_Id,
            UsuarioUltimaAlteracao_Id: session.usuario_Id,
            permiteCadastroDuplicado: permiteCadastroDuplicado,
            cabecalhoCertificado: data.cabecalhoCertificado,
            legislacaoCertificado: data.legislacaoCertificado
        }

        setshowLoading(true);
        if (json_submit.setupSolicitacao_Id == 0) {
            api_POST('SetupSolicitacao', json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
                        set_setupSolicitacao_Id(result.data.setupSolicitacao_Id);
                    });
                }
            });
        }
        else {
            api_PUT('SetupSolicitacao', json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error', null);
                }
                else {
                    showMessage("Aviso", "Operação executada com sucesso!", 'success', null);
                }
            });
        }
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <img src={require("assets/img/loading.gif")}></img>
                    </div>
                </div>
            }
            <div className="content">
                <Row>
                    <Col md="12">
                        <Button type="button" color="Primary" onClick={Voltar}><i className="fas fa-chevron-left"></i>  Voltar</Button>
                        <Card className="card-user">
                            <CardHeader>
                                <Row><Col md="12" className="text-right"><label className="text-danger">* Campos Obrigatórios</label></Col></Row>
                            </CardHeader>
                            <CardBody>
                                <Nav pills className="nav-pills-primary" style={{ cursor: "pointer" }}>
                                    <NavItem>
                                        <NavLink className={h1_tab === "ht1" ? "link-nav active" : "link-nav"} onClick={() => set_h1_tab("ht1")}><i class="fas fa-cog"></i>  Principal </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink style={{ margin: "0px 10px" }} className={h1_tab === "ht2" ? "link-nav active" : "link-nav"} onClick={() => set_h1_tab("ht2")} ><i class="fas fa-sort-numeric-down"></i>  Ações </NavLink>
                                    </NavItem>
                                </Nav>
                                <TabContent activeTab={h1_tab} className="tab-space tab-principal">
                                    <TabPane tabId="ht1">
                                        <Row>
                                            <Col md="12">
                                                <div className="formPrincipal">
                                                    <Form onSubmit={handleSubmit(onSubmit)}>
                                                        <Row>
                                                            <Col md="12" lg="12">
                                                                <FormGroup>
                                                                    <b><label><span className="text-danger">*</span> Descrição</label></b>
                                                                    <Input
                                                                        type="text"
                                                                        maxLength="100"
                                                                        name="descricao"
                                                                        innerRef={register({ required: true })}
                                                                    />
                                                                    {errors.descricao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md="4" lg="4">
                                                                <FormGroup>
                                                                    <b><label><span className="text-danger">*</span> Status</label> </b>
                                                                    <Select
                                                                        options={options_status}
                                                                        name="status"
                                                                        onChange={(e) => { handleStatus(e.value) }}
                                                                        value={status != "" && options_status.find(obj => obj.value === status)}
                                                                        placeholder="Selecione"
                                                                        ref={e => register(
                                                                            { name: "status" },
                                                                            { required: true })
                                                                        }
                                                                    />
                                                                    {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md="4" lg="4">
                                                                <FormGroup>
                                                                    <b><label><span className="text-danger">*</span> Segmento</label></b>
                                                                    <Select
                                                                        options={options_segmento}
                                                                        name="segmento"
                                                                        onChange={(e) => { handleSegmento(e.value) }}
                                                                        value={segmento != "" && options_segmento.find(obj => obj.value === segmento)}
                                                                        placeholder="Selecione"
                                                                        ref={e => register(
                                                                            { name: "segmento" },
                                                                            { required: true })
                                                                        }
                                                                    />
                                                                    {errors.segmento && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md="4" lg="4">
                                                                <FormGroup>
                                                                    <b><label><span className="text-danger">*</span> Pessoa</label></b>
                                                                    <Select
                                                                        options={options_tipoPessoa}
                                                                        name="tipoPessoa"
                                                                        onChange={(e) => { handleTipoPessoa(e.value) }}
                                                                        value={tipoPessoa != "" && options_tipoPessoa.find(obj => obj.value === tipoPessoa)}
                                                                        placeholder="Selecione"
                                                                        ref={e => register(
                                                                            { name: "tipoPessoa" },
                                                                            { required: true })
                                                                        }
                                                                    />
                                                                    {errors.tipoPessoa && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md="12" lg="12">
                                                                <FormGroup>
                                                                    <b><label><span className="text-danger">*</span> Categoria</label></b>
                                                                    <Select
                                                                        options={options_categoria}
                                                                        name="categoria"
                                                                        getOptionLabel={option => option.descricao}
                                                                        getOptionValue={option => option.categoria_Id}
                                                                        onChange={(e) => { handleCategoria(e.categoria_Id) }}
                                                                        value={categoria != null && options_categoria.find(obj => obj.categoria_Id === categoria)}
                                                                        placeholder="Selecione"
                                                                        ref={e => register(
                                                                            { name: "categoria" },
                                                                            { required: true })
                                                                        }
                                                                    />
                                                                    {errors.categoria && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md="3">
                                                                <FormGroup>
                                                                    <b><label><span className="text-danger">*</span> Vigência</label></b>
                                                                    <InputGroup>
                                                                        <Input type="number" name="vigencia" innerRef={register({ required: true })} />
                                                                        <InputGroupAddon addonType="append">
                                                                            <InputGroupText>Meses</InputGroupText>
                                                                        </InputGroupAddon>
                                                                    </InputGroup>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md="3">
                                                                <FormGroup>
                                                                    <b><label><span className="text-danger">*</span> 1º Notificação</label></b>
                                                                    <InputGroup>
                                                                        <Input type="number" name="primeiraNotificacao" innerRef={register()} />
                                                                        <InputGroupAddon addonType="append">
                                                                            <InputGroupText>Dias</InputGroupText>
                                                                        </InputGroupAddon>
                                                                    </InputGroup>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md="3">
                                                                <FormGroup>
                                                                    <b><label><span className="text-danger">*</span> 2º Notificação</label></b>
                                                                    <InputGroup>
                                                                        <Input type="number" name="segundaNotificacao" innerRef={register()} />
                                                                        <InputGroupAddon addonType="append">
                                                                            <InputGroupText>Dias</InputGroupText>
                                                                        </InputGroupAddon>
                                                                    </InputGroup>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md="3">
                                                                <FormGroup>
                                                                    <b><label><span className="text-danger">*</span> 3º Notificação</label></b>
                                                                    <InputGroup>
                                                                        <Input type="number" name="terceiraNotificacao" innerRef={register()} />
                                                                        <InputGroupAddon addonType="append">
                                                                            <InputGroupText>Dias</InputGroupText>
                                                                        </InputGroupAddon>
                                                                    </InputGroup>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg="12" md="6" className="mb-4">
                                                                <span>Permite cadastro duplicado no CNPJ/CPF &nbsp;</span>
                                                                <Switch onChange={(event) => handleChangePermiteCadastroDuplicado(event)} checked={permiteCadastroDuplicado} height={20} width={35} />
                                                            </Col>
                                                            <Col md="12">
                                                                <FormGroup>
                                                                    <b><label>Descrição de declaração  </label></b>
                                                                    <Input type="textarea" name="declaracao" innerRef={register()} />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md="12">
                                                                <FormGroup>
                                                                    <b><label>Cabeçalho Certificado  </label></b>
                                                                    <Input type="textarea" name="cabecalhoCertificado" innerRef={register()} />
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md="12">
                                                                <FormGroup>
                                                                    <b><label>Legislação Certificado  </label></b>
                                                                    <Input type="textarea" name="legislacaoCertificado" innerRef={register()} />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md="12" className="text-center">
                                                                <Button color="success" disabled={!permiteEditar} className="btn-mobile" type="submit"><i className="fas fa-save"></i>  Salvar</Button>
                                                            </Col>
                                                        </Row>
                                                    </Form>
                                                </div>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="ht2">
                                        <Row>
                                            <Col md="12">
                                                <div >
                                                    <Row>
                                                        <Col md="4" lg="4">
                                                            <FormGroup>
                                                                <b><label><span className="text-danger">*</span> Ações</label> </b>
                                                                <Select
                                                                    options={options_acao}
                                                                    name="acao"
                                                                    onChange={(e) => { handleAcao(e.value) }}
                                                                    value={acao != "" && options_acao.find(obj => obj.value === acao)}
                                                                    placeholder="Selecione"
                                                                    ref={e => register({ name: "acao" })}
                                                                    isDisabled={(rowEdit != null && rowEdit.setupSolicitacaoAcao_Id != null) ? true : false}
                                                                />
                                                                {errors.acao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="4" lg="4">
                                                            <FormGroup>
                                                                <b><label><span className="text-danger">*</span> Identificação</label></b>
                                                                <Input
                                                                    type="text"
                                                                    maxLength="50"
                                                                    name="identificacao"
                                                                    innerRef={register()}
                                                                />
                                                                {errors.identificacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="4" lg="4">
                                                            <FormGroup>
                                                                <b><label><span className="text-danger">*</span> Status</label> </b>
                                                                <Select
                                                                    options={options_statusAcao}
                                                                    name="statusAcao"
                                                                    onChange={(e) => { handleStatusAcao(e.value) }}
                                                                    value={statusAcao != "" && options_statusAcao.find(obj => obj.value === statusAcao)}
                                                                    placeholder="Selecione"
                                                                    ref={e => register(
                                                                        { name: "statusAcao" },
                                                                        { required: false })
                                                                    }
                                                                />
                                                                {errors.statusAcao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="6" lg="4">
                                                            <FormGroup>
                                                                <b><label><span className="text-danger">*</span> Enquadramento Obrigatório?</label> </b>
                                                                <Select
                                                                    options={options_enquadramentoObg}
                                                                    name="enquadramentoObg"
                                                                    onChange={(e) => { handleEnquadramentoObg(e.value) }}
                                                                    value={enquadramentoObg != "" && options_enquadramentoObg.find(obj => obj.value == enquadramentoObg)}
                                                                    placeholder="Selecione"
                                                                    ref={e => register(
                                                                        { name: "enquadramentoObg" },
                                                                        { required: false })
                                                                    }
                                                                />
                                                                {errors.enquadramentoObg && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="6" lg="4">
                                                            <FormGroup>
                                                                <b><label><span className="text-danger">*</span> Cancelar Requerimentos?</label> </b>
                                                                <Select
                                                                    options={options_cancelarRequerimentos}
                                                                    name="cancelarRequerimentos"
                                                                    onChange={(e) => { handleCancelarRequerimentos(e.value) }}
                                                                    value={cancelarRequerimentos != "" && options_cancelarRequerimentos.find(obj => obj.value == cancelarRequerimentos)}
                                                                    placeholder="Selecione"
                                                                    ref={e => register(
                                                                        { name: "cancelarRequerimentos" },
                                                                        { required: false })
                                                                    }
                                                                />
                                                                {errors.enquadramentoObg && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="6" lg="4">
                                                            <FormGroup>
                                                                <b><label><span className="text-danger">*</span> Publicação Diário Oficial?</label> </b>
                                                                <Select
                                                                    options={options_diarioOficial}
                                                                    name="diarioOficial"
                                                                    onChange={(e) => { handleDiarioOficial(e.value) }}
                                                                    value={diarioOficial != "" && options_diarioOficial.find(obj => obj.value == diarioOficial)}
                                                                    placeholder="Selecione"
                                                                    ref={e => register(
                                                                        { name: "diarioOficial" },
                                                                        { required: false })
                                                                    }
                                                                />
                                                                {errors.diarioOficial && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="3">
                                                            <FormGroup>
                                                                <b><label><span className="text-danger">*</span> Código Cobrança</label> </b>
                                                                <Input type="text" name="codigoCobranca" className="text-right" innerRef={register()} />
                                                                {errors.codigoCobranca && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="2">
                                                            <FormGroup>
                                                                <b><label><span className="text-danger">*</span> Valor</label> </b>
                                                                <InputGroup>
                                                                    <InputGroupAddon addonType="prepend">R$</InputGroupAddon>
                                                                    <Input min={0} max={100} type="number" name="valor" className="text-right" innerRef={register()} />
                                                                </InputGroup>
                                                                {errors.valor && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="4">
                                                            <FormGroup>
                                                                <b><label><span className="text-danger">*</span> Prazo de Vencimento da Cobrança</label> </b>
                                                                <Input type="number" name="prazoCobranca" innerRef={register()} />
                                                                {errors.prazoCobranca && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                                            </FormGroup>
                                                        </Col>
                                                        <Col md="3">
                                                            <Button color="primary" className="btn-mobile" onClick={toggleModalDocumentos} style={{ width: "100%" }}><i class="fas fa-file-alt"></i>  Documentos</Button>
                                                        </Col>
                                                        <Col md="12" className="text-center">
                                                            <Button color="success" className="btn-mobile" type="button" onClick={handleAdicionarAcao} disabled={!permiteEditar}><i className="fas fa-save"></i> Salvar</Button>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col md="12">

                                                            <MaterialTable style={{ minHeight: "auto" }}
                                                                title=""
                                                                columns={[
                                                                    { title: 'Ação', field: 'acao' },
                                                                    { title: "Identificação", field: "identificacao"},
                                                                    { title: 'Enquadramento Obrigatório', field: 'enquadramentoObrigatorio', render: (rowData) => rowData.enquadramentoObrigatorio ? "Sim" : "Não" },
                                                                    { title: 'Publição para o Diario Oficial', field: 'publicaDiarioOficial', render: (rowData) => rowData.publicaDiarioOficial ? "Sim" : "Não" },
                                                                    { title: 'Código de Cobrança', field: 'codigoCobranca' },
                                                                    { title: 'Valor', field: 'valorGuia', render: (rowData) => transformValueFloattoFormated(rowData.valorGuia), type: 'numeric', cellStyle: { textAlign: "right" } },
                                                                    { title: 'Prazo Vencimento Cobrança', field: 'prazoVencimentoCobrancaEmDias', type: 'numeric', cellStyle: { textAlign: "right" } },
                                                                    { title: 'Status', field: 'status' }
                                                                ]}
                                                                data={list_table_acoes}
                                                                isLoading={false}
                                                                options={{
                                                                    headerStyle: {
                                                                        fontFamily: 'Montserrat, Helvetica Neue, Arial, sans-serif',
                                                                        fontWeight: '700',
                                                                        color: '#888'
                                                                    },
                                                                    filtering: false,
                                                                    exportButton: true
                                                                }}
                                                                actions={[
                                                                    {
                                                                        icon: 'edit',
                                                                        tooltip: 'Editar Registro',
                                                                        onClick: (event, rowData) => handleEditarAcao(rowData)
                                                                    },
                                                                    {
                                                                        icon: 'delete',
                                                                        tooltip: 'Deletar Registro',
                                                                        onClick: (event, rowData) => handleDeleteAcao(rowData)
                                                                    }
                                                                ]}
                                                                localization={{
                                                                    header: {
                                                                        actions: ''
                                                                    },
                                                                    body: {
                                                                        emptyDataSourceMessage: 'Nenhum registro para exibir',
                                                                        editRow: {
                                                                            cancelTooltip: "Cancelar",
                                                                            saveTooltip: "Salvar"
                                                                        },
                                                                        deleteTooltip: "Excluir",
                                                                        editTooltip: "Editar"
                                                                    },
                                                                    toolbar: {
                                                                        searchTooltip: 'Pesquisar',
                                                                        searchPlaceholder: 'Pesquisar'
                                                                    },
                                                                    pagination: {
                                                                        labelRowsSelect: 'linhas',
                                                                        labelDisplayedRows: '{count} de {from}-{to}',
                                                                        firstTooltip: 'Primeira página',
                                                                        previousTooltip: 'Página anterior',
                                                                        nextTooltip: 'Próxima página',
                                                                        lastTooltip: 'Última página'
                                                                    }
                                                                }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Modal isOpen={modal} toggle={toggleModalDocumentos}>
                    <ModalHeader toggle={toggleModalDocumentos} close={<button className="close" onClick={toggleModalDocumentos}>&times;</button>} className="md-hd"><i class="fas fa-file-alt"></i>  Documentos</ModalHeader>
                    <ModalBody className="md-bd">
                        <div>
                            {optionsDocumentos.map(item => (
                                <Row key={item.documento_Id}>
                                    <Col md="11">
                                        <CustomInput
                                            type="switch"
                                            id={item.documento_Id}
                                            defaultChecked={optionsDocumentosSelected.filter(f => f == item.documento_Id).length > 0}
                                            name="customSwitch"
                                            label={item.descricao}
                                            onChange={(event) => handleDocumentoChange(event.target.checked, item.documento_Id)}
                                        />
                                    </Col>
                                    <Col md="1">
                                        {item.orientacao != null && item.orientacao != "" && <i class="fas fa-info-circle" onClick={() => showMessage(item.orientacao, "", null, null)}></i>}
                                    </Col>
                                </Row>
                            ))}
                        </div>
                    </ModalBody>
                    <ModalFooter className="md-ft">
                        <Button color="success" onClick={confirmarModalDocumentos} disabled={!permiteEditar}><i className="fas fa-check"></i>  Confirmar</Button>
                        <Button color="secondary" onClick={toggleModalDocumentos}>Cancelar</Button>
                    </ModalFooter>
                </Modal>

            </div>

        </>
    );
}

